export function copyClassInstance<T>(object: T): T {
    return Object.create(
        Object.getPrototypeOf(object),
        Object.getOwnPropertyDescriptors(object),
    );
}
